import { render, staticRenderFns } from "./Requirements.vue?vue&type=template&id=bda528e4&scoped=true"
import script from "./Requirements.vue?vue&type=script&lang=js"
export * from "./Requirements.vue?vue&type=script&lang=js"
import style0 from "./Requirements.vue?vue&type=style&index=0&id=bda528e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda528e4",
  null
  
)

export default component.exports